import { QueryClient } from "@tanstack/react-query";

export const timetableQueryKey = "timetables";

export const invalidateTimetableCache = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: [timetableQueryKey] });
}
